import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useFirebaseApp } from 'reactfire'
import 'firebase/firestore'

const Header=()=>{
  const [state, setstate] = useState({categories:[]})
  const firebase=useFirebaseApp()
  // firebase.analytics()
  const firestore=firebase.firestore()

  const toggleModal=()=>{
    document.getElementById('menu-modal').classList.toggle('active')
  }

  useEffect(()=>{
    firestore.collection('categories').get().then(querySnapshot=>{
      const categories=[]
      querySnapshot.forEach((doc)=>{
        categories.push({id:doc.id,name:doc.data().name})
      })
      setstate({
        categories
      })
    })
    
  },[firestore])

  return (
    <header className='header' id='header'>
      <div className="logo-container">
        <Link to='/'><img src="/logo.svg" alt="logo-yourstyles"/></Link>
      </div>
      <nav className="menu-container">
        <div className="menu-icon-container" id='open' onClick={()=>toggleModal()}>
          <img src="/icons/menu-toggle.svg" alt=""/>
        </div>
        <div className="menu-box" id='menu-modal'>
        <div className="close" id='close' onClick={()=>toggleModal()}>
          <img src="/icons/close.svg" alt="boton-cerrar"/>
        </div>
        <div className="menu-list-container">
          <ul className="menu-list">
            <li className="menu-item" onClick={()=>toggleModal()} ><NavLink to='/'>Inicio</NavLink></li>
            {
              state.categories &&
              state.categories.map(c=>(
                <li key={c.id} className="menu-item" onClick={()=>toggleModal()} ><NavLink to={`/categorias/${c.id}`}>{c.name}</NavLink></li>
              ))
            }
          </ul>
        </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
